import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const formatApiError = (e, fallback = "Kuch galat ho gaya. Dobara try karein.") => {
  const detail = e?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d?.msg ? String(d.msg) : JSON.stringify(d))).join(", ");
  if (typeof detail?.msg === "string") return detail.msg;
  return fallback;
};

export const fileUrl = (url) => (url && url.startsWith("/") ? `${BACKEND_URL}${url}` : url || "");

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const waLink = (number, text) =>
  `https://wa.me/${(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export const orderMessage = (product) =>
  `Hello Ira Lakshmi! I would like to order:\n\n${product.name}\nPrice: ${inr(product.price)}\n\nIs it available?`;

export const generalMessage = "Hello Ira Lakshmi! I would like to know more about your collection.";

api.interceptors.response.use(undefined, (error) => {
  if (error?.config?.url && error.config.url.includes("/admin/") && error?.response?.status === 401) {
    window.dispatchEvent(new CustomEvent("auth:expired"));
  }
  return Promise.reject(error);
});
